import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import App from './App';

// Guard against environments where localStorage is blocked (Telegram WebApp,
// sandboxed iframes, strict browser privacy settings). Install an in-memory
// shim so the app renders instead of throwing a SecurityError.
try {
  localStorage.getItem('__ls_test__');
} catch {
  const _mem = {};
  try {
    Object.defineProperty(window, 'localStorage', {
      value: {
        getItem:    (k) => Object.prototype.hasOwnProperty.call(_mem, k) ? _mem[k] : null,
        setItem:    (k, v) => { _mem[k] = String(v); },
        removeItem: (k) => { delete _mem[k]; },
        clear:      () => { Object.keys(_mem).forEach(k => delete _mem[k]); },
        get length() { return Object.keys(_mem).length; },
      },
    });
  } catch { /* environment won't allow patching either — best effort */ }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
